import { $authHost } from ".."

// export const checkPackAPI = async ({ keyCrmOrderNumber }) => {
//     const {data} = await $authHost.post('api/pack/check', {keyCrmOrderNumber})
//     return data
// }

export const addBoxInPack = async ({ packId }) => {
    const {data} = await $authHost.post(`api/boxes/pack/${packId}`)
    return data
}

export const getPackBoxesAPI = async ({ packId, offset, limit, query }) => {

    let params = `?packId=${packId}`
    if (query) {
        params += `&query=${query}`
    } else if ((offset || offset === 0) && limit) {
        params += `&offset=${offset}&limit=${limit}`
    }

    const {data} = await $authHost.get(`api/boxes/pack/${params}`)
    return data
}

export const getBoxQrCodesAPI = async ({ boxId, type }) => {
    let params = ''

    if (type) {
        params = `?type=${type}`
    }

    const {data} = await $authHost.get(`api/boxes/qr_codes/${boxId}${params}`)
    return data
}

export const getBoxFilePassportAPI = async ({ boxId, typeFile }) => {
    let params = ''

    if (typeFile) {
        params = `?typeFile=${typeFile}`
    }

    const {data} = await $authHost.get(`api/boxes/file_passport/${boxId}${params}`)
    return data
}